import { TransferBaseModel } from '../../transfer-base.model';
import { BridgerRefund } from './bridger-refund';

export interface PayoutRefund extends TransferBaseModel {
    withdrawal_id?: string;
    withdrawal_reference_id?: string;
    deposit_id?: string;
    deposit_reference_id?: string;
    user?: string;
    amount?: number;
    currency?: string;
    status?: string;
    created_date?: string;
    bridger_refund_info?: BridgerRefund;
}
